import { render, staticRenderFns } from "./ShowcaseTemplatesTable.vue?vue&type=template&id=562c23dc&"
import script from "./ShowcaseTemplatesTable.vue?vue&type=script&lang=ts&"
export * from "./ShowcaseTemplatesTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports